// @ts-nocheck
import { Provider } from '@angular/core';
import { NG_DOC_CONTEXT, NG_DOC_ROUTE_PREFIX, NG_DOC_SHIKI_THEME } from '@ng-doc/app/tokens';

export function provideNgDocContext(): Provider[] {
  return [{
    provide: NG_DOC_CONTEXT,
    useValue: {
      navigation: [
          
        {
          title: `Getting Started`,
          route: '/getting-started',
          expandable: true,
          expanded: true,
          order: 1,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `What is`,
          route: '/getting-started/what-is',
          order: 1,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Peer dependency`,
          route: '/getting-started/peer-dependency',
          order: 2,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Install`,
          route: '/getting-started/install',
          order: 3,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Usage`,
          route: '/getting-started/usage',
          order: 4,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Docs`,
          route: '/getting-started/docs',
          order: 5,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Migration`,
          route: '/getting-started/migration',
          order: 6,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Changelog`,
          route: '/getting-started/changelog',
          order: 7,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
          ]
        },
          
        {
          title: `Mtheme`,
          route: '/m-theme',
          expandable: true,
          expanded: false,
          order: 2,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `Breakpoints`,
          route: '/m-theme/breakpoints',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Classes`,
          route: '/m-theme/classes',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Colors`,
          route: '/m-theme/colors',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Elevation`,
          route: '/m-theme/elevation',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Other Variables`,
          route: '/m-theme/other-variables',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Shapes/Radius`,
          route: '/m-theme/corner',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Spacing`,
          route: '/m-theme/spacing',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Typography`,
          route: '/m-theme/typography',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
          ]
        },
          
        {
          title: `M-ui`,
          route: '/m-ui',
          expandable: true,
          expanded: false,
          order: 3,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `M-ace-editor`,
          route: '/m-ui/m-ace-editor',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-affluence`,
          route: '/m-ui/m-affluence',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-app-download`,
          route: '/m-ui/m-app-download',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-badges`,
          route: '/m-ui/m-badges',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-bottom-bar`,
          route: '/m-ui/m-bottom-bar',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-button-link`,
          route: '/m-ui/m-button-link',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-disturbance-display`,
          route: '/m-ui/m-disturbance-display',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-drop-files`,
          route: '/m-ui/m-drop-files',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-etiquette`,
          route: '/m-ui/m-etiquette',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-event-dialog`,
          route: '/m-ui/m-event-dialog',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-icon-button`,
          route: '/m-ui/m-icon-buton',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-icons`,
          route: '/m-ui/m-icons',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-list`,
          route: '/m-ui/m-list',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-list-wrapper`,
          route: '/m-ui/m-list-wrapper',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-logo-lines`,
          route: '/m-ui/m-logo-lines',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-notifications`,
          route: '/m-ui/m-notifications',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-progress-spinner`,
          route: '/m-ui/m-progress-spinner',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-scroll`,
          route: '/m-ui/m-scroll',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-table`,
          route: '/m-ui/m-table',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-theme-toggle`,
          route: '/m-ui/m-theme-toggle',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-toolbar`,
          route: '/m-ui/m-toolbar',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
          ]
        },
          
        {
          title: `M-Tools`,
          route: '/m-service',
          expandable: true,
          expanded: false,
          order: 4,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `M-error-service (SERVICE)`,
          route: '/m-service/m-error-service',
          order: 1,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-url-utils`,
          route: '/m-service/m-url-utils',
          order: 2,
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-files`,
          route: '/m-service/m-files',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `M-providers`,
          route: '/m-service/m-providers',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
          ]
        },
          
        {
          title: `Angular-material`,
          route: '/angular-materiel',
          expandable: true,
          expanded: false,
          order: 5,
          hidden: false,
          metadata: {"description":"","tags":{}},
          children: [
              
        {
          title: `Autocomplete`,
          route: '/angular-materiel/material-autocomplete',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Badge`,
          route: '/angular-materiel/material-badge',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Bottom-sheet`,
          route: '/angular-materiel/material-bottom-sheet',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Button`,
          route: '/angular-materiel/material-button',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Button-toggle`,
          route: '/angular-materiel/material-button-toggle',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Card`,
          route: '/angular-materiel/material-card',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Checkbox`,
          route: '/angular-materiel/material-checkbox',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Chips`,
          route: '/angular-materiel/material-chips',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Datepicker`,
          route: '/angular-materiel/material-datepicker',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Dialog`,
          route: '/angular-materiel/material-dialog',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Divider`,
          route: '/angular-materiel/material-divider',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Expansion Panel`,
          route: '/angular-materiel/material-expansion-panel',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Form field`,
          route: '/angular-materiel/material-form-field',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Input`,
          route: '/angular-materiel/material-input',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `List`,
          route: '/angular-materiel/material-list',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Progress bar`,
          route: '/angular-materiel/material-progress-bar',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Progress spinner`,
          route: '/angular-materiel/material-progress-spinner',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Radio`,
          route: '/angular-materiel/material-radio',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Ripples`,
          route: '/angular-materiel/material-ripples',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Select`,
          route: '/angular-materiel/material-select',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Sidenav`,
          route: '/angular-materiel/material-sidenav',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Slide toggle`,
          route: '/angular-materiel/material-slide-toggle',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Slider`,
          route: '/angular-materiel/material-slider',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Snackbar`,
          route: '/angular-materiel/material-snackbar',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Sort header`,
          route: '/angular-materiel/material-sort-header',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Stepper`,
          route: '/angular-materiel/material-stepper',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Table`,
          route: '/angular-materiel/material-table',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Tabs`,
          route: '/angular-materiel/material-tabs',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Timepicker`,
          route: '/angular-materiel/material-timepicker',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Toolbar`,
          route: '/angular-materiel/material-toolbar',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Tooltip`,
          route: '/angular-materiel/material-tooltip',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
              
        {
          title: `Tree`,
          route: '/angular-materiel/material-tree',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
          ]
        },
          
        {
          title: `API`,
          route: '/api',
          hidden: false,
          metadata: {"description":"","tags":{}},
        },
      ],
    },
  }, {
    provide: NG_DOC_ROUTE_PREFIX,
    useValue: '',
  }, {
    provide: NG_DOC_SHIKI_THEME,
    useValue: {
      light: 'github-light',
      dark: 'github-dark',
    },
  }];
}
